<template>
  <MenuItem :data="diagnosisList" header="Driver"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';
export default {
  name: 'DiagnosisDriver',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisDriver',
          img: 'item_part_driver.png',
          item: 'Driver',
          path: ''
        },
        {
          id: 'diagnosisBack',
          img: 'item_back.png',
          item: 'Back',
          path: '/service-tools/diagnosis'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'confirm'
        }
      ]
    };
  }
};
</script>
